export const bounded = (regex: RegExp): RegExp => new RegExp(`^${regex.source}$`, regex.flags);

export const escapeRegex = (input: string): string => input.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
